const $inject = [];
const lbaODataIndexMultiSelect = function () {
  return {
    restrict: 'A',
    scope:{
      settings: '<',
    },
    bindToController: true,
    controller: 'lbaODataIndexMultiSelectCtrl',
    controllerAs: 'vm',
    template: require('./lbaODataIndexMultiSelect.html')
  }
};

lbaODataIndexMultiSelect.$inject = $inject;

export default lbaODataIndexMultiSelect;



// WEBPACK FOOTER //
// ./src/components/lbaODataIndexMultiSelect/lbaODataIndexMultiSelectDir.js